/*
 * @Author: cc
 * @Date: 2020-12-24 16:51:58
 * @LastEditTime: 2020-12-30 17:19:28
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\kuaishou\kuaishouLeft.js
 * @Description: 快手左侧导航部分
 */
angular.module('editKuaishouLeftModule', []).controller('EditKuaishouLeftCtrl', [
    '$scope',
    '$element',
    '$controller',
    'editingMediatype',
    function ($scope, $element, $controller, editingMediatype) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus(){
            $scope.trench = {
                params: {
                    MediaType: editingMediatype.kuaishou,
                    PAGESIZE: 1000,
                    methodname: 'queryWebSitesByMediaType',
                    serviceid: 'mlf_mediasite'
                },
                accountKey: 'ACCOUNTID', // 因为原有接口返回的跟现在不一致，需要一个标识区分主键ID
                router: 'kuaishou',
                mediaType: editingMediatype.kuaishou,
            };
        }
        $controller('EditShortVideoLeftCtrl', {$scope: $scope, $element: $element}); // This works
    }]);
